<template>
  <div class="etr">
    <b-card v-if="item" class="mt-3">
      <b-card-header>
        <b-row align-v="top" no-gutters>
          <b-col cols="7" class="text-left">
            <b-button
              v-print="'#paper'"
              squared
              size="sm"
              class="mr-4 inline"
              title="Print"
              :disabled="busy"
            >
              <i class="fa fa-print pr-3"></i>Print
            </b-button>
            <div class="inline-block">
              <i class="fa fa-book fa-2x mr-1 text-primary"></i>
              <span class="h4 ml-1 text-primary"
                >Locator: {{ item.locator }}</span
              >
            </div>
          </b-col>
          <b-col class="text-right">
            <b-button-group>
              <b-button
                class="mr-1"
                squared
                size="sm"
                variant="secondary"
                @click="discard"
              >
                <i class="fa fa-chevron-left pr-1"></i>Back
              </b-button>
              <b-button squared size="sm" variant="primary" @click="download()">
                <i
                  :class="
                    busy
                      ? 'fa fa-spinner fa-spin pr-3'
                      : 'fa fa-file-pdf-o pr-3'
                  "
                ></i
                >Download
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-overlay :show="busy" rounded="sm">
          <div id="paper" class="mb-3 p-4 background-white text-secondary">
            <b-row>
              <b-col>
                <b-row align-h="end">
                  <b-col cols="auto ssh-pre mr-4">
                    <span>Received: </span>
                    <span>{{$moment
                          .unix(item.dateissued / 1000)
                          .utc(false)
                          .format('DD/MM/YYYY HH:mm:ss')}}</span>
                    <!-- <span
                      v-html="
                        this.$moment
                          .unix(item.dateissued / 1000)
                          .utc()
                          .format('DD/MM/YYYY HH:mm:ss')
                      "
                    ></span> -->
                  </b-col>
                </b-row>

                <ssh-pre
                  language="xml"
                  :label="item.fileref"
                  class="large mt-6"
                  >{{ xmldata }}</ssh-pre
                >
                <!-- format(JSON.parse(item.data) , {
                          indentation: '  ', 
                          filter: (node) => node.type !== 'Comment', 
                          collapseContent: true, 
                          lineSeparator: '\n'
                      }) -->
                <!-- '<?xml version="1.0" encoding="utf-8"?>' +  -->
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card-body>

      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-right">
            <b-button squared size="sm" variant="secondary" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import formatXML from "xml-formatter";
import SshPre from "simple-syntax-highlighter";
import "simple-syntax-highlighter/dist/sshpre.css";

import * as fs from "file-saver";

export default {
  name: "PNRXml",
  components: {
    SshPre,
  },
  data() {
    return {
      loading: false,
      documentformat: "PNR_1",
      item: {},
      id: null,
      locator: null,
      data: null,
      fileref: null,

      dateissued: null,
    };
  },
  computed: {
    xmldata() {
      // let result = JSON.parse(this.item.data);
      let result = Buffer.from(this.item.documentxml, "base64").toString(
        "ascii"
      );
      result = formatXML(result, {
        indentation: "  ",
        filter: (node) => node.type !== "Comment",
        collapseContent: true,
        lineSeparator: "\n",
      });
      return result;
    },
  },
  methods: {
    async load() {
      this.busy = true;

      let variables = {
        id: this.idselected,
        dateformat: "DD/MM/YYYY HH:MM:SS",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query pnrs($id: String, $dateformat: String) {
              pnrs(id: $id, dateformat: $dateformat) {
                id
                locator
                fileref
                documentxml

                dateissued
              }
            }
          `,
          variables,
        });

        this.item = response.data.pnrs[0];
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async download() {
      this.busy = true;
      let variables = {
        id: this.idselected,
        dateformat: "DD/MM/YYYY HH:MM:SS",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query pnrs($id: String, $dateformat: String) {
              pnrs(id: $id, dateformat: $dateformat) {
                id
                fileref
                documentxml

                dateissued
              }
            }
          `,
          variables,
        });

        if (response.data.pnrs.length > 0) {
          console.log(response.data.pnrs[0]);

          let fileparts = response.data.pnrs[0].fileref.split("/");
          let filename = fileparts[fileparts.length - 1];

          let byteCharacters =
            "<?xml version='1.0' encoding='utf-8'?>" +
            Buffer.from(response.data.pnrs[0].documentxml, "base64").toString(
              "ascii"
            );

          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          let byteArray = new Uint8Array(byteNumbers);
          let blob = new Blob([byteArray], { type: "application/xml" });
          fs.saveAs(blob, filename);
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
  },
};
</script>

<style>
.ssh-pre__content {
  color: #3cb450;
}
.ssh-pre .quote {
  color: #0bc;
}
.ssh-pre[data-type="xml"] .tag-name {
  color: #c6d;
}
</style>